<template>
	<card-container class="mt-3">
		<v-layout wrap align-center justify-space-between px-4 py-3>
			<v-flex xs8 caption info--text>
				<v-layout wrap align-center>
					<v-flex xs12>
						{{ name }}
					</v-flex>
					<v-flex xs8>
						<progress-bar
							:quantity="quantity"
							:value="value"
						></progress-bar>
					</v-flex>
					<v-flex class="ml-2 complete-container">
						<v-icon
							:disabled="!complete"
							color="success"
							size="20"
						>
							check_circle
						</v-icon>
						<span v-show="complete" class="success--text">Completo</span>
					</v-flex>
				</v-layout>
			</v-flex>
			<v-flex xs4 text-xs-right>
				<v-btn
					class="btn-action btn-auto primary py-2 px-4 btn-disabled-background"
					:disabled="disabled"
					@click="$emit('on-click')"
				>
					Siguiente Factor
				</v-btn>
			</v-flex>
		</v-layout>
	</card-container>
</template>

<script>
	import cardContainer from '@/components/shared/card-container';
	import progressBar from '@/components/shared/progress-bar';

	export default {
		name: 'progress-weighing',
		components: {
			cardContainer,
			progressBar,
		},
		props: {
			complete: {
				default: false,
				type: Boolean,
			},
			disabled: {
				default: true,
				type: Boolean,
			},
			name: String,
			quantity: Number,
			value: Number,
		},
	};
</script>

<style lang="scss" scoped>
	.complete-container {
		.v-icon, span {
			vertical-align: middle;
		}

		span {
			font-size: 9px;
		}
	}

	.btn-action {
		font-family: map-get($fonts, bold);
	}
</style>



// WEBPACK FOOTER //
// src/components/surveys/progress-weighing.vue